import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

/**
 * Collapsible group heading in a sidebar ("PRODUCTS", "CUSTOMERS", …).
 *
 * Presentational only — the consumer owns the collapsed flag and keeps using it
 * to show/hide the group's items:
 *
 *   <ui-nav-section [label]="'import.product' | translate"
 *                   [collapsed]="toggleProduits"
 *                   (toggled)="toggle('produits')"></ui-nav-section>
 *   <div class="module_container" *ngIf="!toggleProduits"> … </div>
 */
@Component({
  selector: 'ui-nav-section',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './nav-section.component.html',
  styleUrls: ['./nav-section.component.scss'],
})
export class NavSectionComponent {
  @Input() label = '';

  /** True when the group's items are hidden. */
  @Input() collapsed = false;

  @Output() toggled = new EventEmitter<void>();
}
